import styled from 'styled-components';

export const StyledCheckoutPage = styled.div`
    font-family: var(--bllink-font-primary);
    color: #373647;

    .payment-page {
        font-weight: 700;
        font-size: 26px;
        margin-bottom: 30px;
        text-align: start;
    }

    .credit-card-and-actions-block {
        border: 1px solid #DCDCE2;
        box-shadow: none;
        padding: 20px;

        .checkout {
            .checkout-title {
                font-weight: 700;
                font-size: 20px;
                color: #373647;
                display: flex;
                gap: 12px;
                align-items: center;
                margin-bottom: 16px;

                .show-details {
                    font-size: 16px;
                    text-decoration-line: underline;
                    color: #6E74FF;
                    cursor: pointer;
                }
            }

            .months-wrapper {
                border-top: 1px solid #F3F1FF;
                margin-bottom: 18px;

                .month-info {
                    display: grid;
                    grid-template-columns: repeat(3, 1fr);
                    border-bottom: 1px solid #F3F1FF;
                    padding: 12px 30px;

                    .month {
                        justify-self: center;
                    }

                    .year {
                        text-align: start;
                    }

                    .currency-value {
                        font-weight: 700;
                        justify-self: flex-end;
                    }
                }
            }

            .one-time-title {
                font-weight: 700;
                margin-bottom: 5px;
                text-align: start;
            }
         
            .dropdown__control {
                height: 28px;
            }
        }
    }

    .payment-info {
        margin: 40px 0px 29px;
        padding-bottom: 32px;
        border-bottom: 1px solid #F3F1FF;
        font-size: 20px;

        .checkout-label {
            color: rgba(55, 54, 71, 0.7);
            margin-bottom: 0;
        }

        .dropdown-wrapper {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 25px;
            
            .bllink-input-border {
                height: 44px;
                border-radius: 30px !important;
            }
        }

        .payment-type {
            margin-bottom: 14px;
            text-align: start;
        }

        .dropdown__control {
            height: 44px;
        }
      
      .disable-installment-note {
        margin-bottom: 10px;
        text-align: start;
      }
      .payment-commission-note {
        margin-bottom: 10px;
        text-align: start;
        font-size: 0.75em;
      }
    }

    .dropdown__control {
        border-radius: 30px;
    }
  
  .total-first-payment-wrapper {
    display: flex;
    flex-direction: column;
    text-align: start;
    .total-first-payment {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 26px;

      .currency-value {
        font-weight: 700;
      }
    }
    .out-of-range {
      font-size: 16px;
      font-weight: 700;
      margin-top: 10px;
    }
  }
  
    .payment-note {
        font-size: 14px;
        color: rgba(55, 54, 71, 0.7);
        max-width: 350px;
        margin: 4px 0 40px;
        text-align: start;

        .bank-comission-note {
            margin-top: 10px;
        }
    }

    .btn-wrapper {
        width: 100%;
        margin-top: 70px;
        display: flex;
        justify-content: flex-end;

        .app-btn {
            font-family: var(--bllink-font-headers);
            font-weight: 400;
            width: 200px;
            height: 60px;
            font-size: 20px;
            position: relative;
    
            .arrow {
                transform: ${({ ltr }) => ltr ? 'rotate(180deg)' : 'rotate(0deg)'};
                position: absolute;
                right: ${({ ltr }) => ltr ? '10px' : ''};
                left: ${({ ltr }) => ltr ? '' : '10px'};
            }
        }
    }

    @media screen and (max-width: 768px) {
        width: 90%;
        
        .credit-card-and-actions-block {
            width: 100%;
          
            .checkout {
                .months-wrapper {
                    .month-info {
                        padding: 12px 0;
                    }
                }
            }
        }
    
        .payment-info {
            margin: 44px 0px 29px;
            padding-bottom: 67px;
    
            .dropdown-wrapper {
                flex-direction: column;
                align-items: start;
                gap: 12px;
                margin-bottom: 28px;
                
                .bllink-input-border {
                    width: 171px;
                }
            }
    
            .payment-type {
                margin-bottom: 14px;
                text-align: start;
            }
    
            .dropdown__control {
                height: 44px;
            }
        }
    }
`
